export default "__VITE_ASSET__d9cc23fe__"